import { types } from 'mobx-state-tree';
import createStore from 'modules/widgets/lib/create-store';

const ActModel = types.model('ActModelModel', {
  key: '',
  title: '',
  desc: '',
  pic: '',
  href: '',
  // begin:
  // end:
});
const GiftMapModel = types
  .model('ActCenterModel', {
    list: types.array(ActModel),
    fortuneCat: ActModel,
    enableFortuneCat: false,
    currentPage: 0,
    pageSize: 4,
    // currentSection:types.safeReference(GiftSectionModel)
  })
  .views((self) => {
    return {
      get allList() {
        if (self.enableFortuneCat) {
          return [self.fortuneCat, ...self.list];
        }
        return self.list;
      },
      get totalPage() {
        return Math.ceil(this.allList.length / self.pageSize);
      },
      get hasPrev() {
        return this.totalPage > 1 && self.currentPage > 0;
      },
      get hasNext() {
        return this.totalPage > 1 && self.currentPage < this.totalPage - 1;
      },
    };
  })
  .actions((self) => {
    const updateList = (list) => {
      self.list = list;
    };

    const toNext = () => {
      if (self.hasNext) {
        self.currentPage += 1;
      }
    };

    const toPrev = () => {
      if (self.hasPrev) {
        self.currentPage -= 1;
      }
    };

    const updateFortuneCat = (status: boolean) => {
      self.enableFortuneCat = status;
    };

    const setPageSize = (size) => {
      self.pageSize = size;
      self.currentPage = 0;
    };

    return {
      updateList,
      toPrev,
      toNext,
      updateFortuneCat,
      setPageSize,
    };
  });

const initState = {
  fortuneCat: {
    key: 'fortuneCat',
    title: '招财猫奖池',
    pic: 'https://img-photo.sumeme.com/0/0/0_1802_1802.png',
  },
};

const storeInfo: any = createStore(GiftMapModel, initState);
const { store, Provider, useStore } = storeInfo;

export { store, Provider, useStore };
